<template>
  <div>
    <Header></Header>
    <v-layout class="margin-top-40px" row wrap>
      <v-flex xs12 xl12 md12 sm12 lg12>
        <div class="title text-xs-center form-divider margin-top-40px mb-2">
          <v-btn class="indigo darken-4" large outline flat>لیست درخواست نمایندگی</v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row class="margin-top-40px">
      <v-flex xs12 lg12 sm12 xl12 md12>
        <v-tabs dark color="indigo" show-arrows>
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab v-for="i in TabItems" :href="'#' + i.path" :key="i.path">
            <v-icon>{{i.icon}}</v-icon>
            {{i.title}}
          </v-tab>
          <v-tabs-items>
            <v-tab-item id="Users">
              <v-card class="full-width">
                <v-data-table
                  :loading="datatableBool"
                  no-data-text="داده ای یافت نشد"
                  next-icon="$vuetify.icons.prev"
                  prev-icon="$vuetify.icons.next"
                  rows-per-page-text="تعداد سطر در هر صفحه :"
                  :headers="adminTableHeader"
                  :items="pendingItems"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-right">{{props.item.username}}</td>
                    <td class="text-xs-right">{{props.item.name}}</td>
                    <td class="text-xs-right">{{props.item.phone}}</td>
                    <td class="text-xs-right">{{props.item.email}}</td>
                    <td class="text-xs-right">{{props.item.raceName}}</td>
                    <td class="text-xs-right">{{props.item.category.name}}</td>
                    <td class="text-xs-right">{{props.item.startDate}}</td>
                    <td class="text-xs-right">{{props.item.endDate}}</td>
                    <td class="text-xs-right">{{props.item.totalCapacityCount}}</td>
                    <td class="text-xs-right">
                      <span v-if="props.item.isSubmit" color="green">قبول</span>
                      <p v-if="!props.item.isSubmit" color="red">رد</p>
                    </td>
                    <td class="text-xs-right">
                      <v-btn
                        flat
                        icon
                        @click="accept(props.item.agentID,props.item.raceID,props.item.id)"
                        color="success"
                      >
                        <v-icon color="s">done</v-icon>
                      </v-btn>
                      <v-btn icon flat @click="refuse" color="error">
                        <v-icon color="error">delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-flex>
    </v-layout>
    <v-snackbar :color="color" v-model="snackbar">{{msg}}</v-snackbar>
    <v-dialog v-model="loading" persistent fullscreen content-class="loading-dialog">
      <v-container fill-height>
        <v-layout row justify-center align-center>
          <v-progress-circular indeterminate :size="70" :width="7" color="purple"></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
  </div>
</template>

<script>
import PendingRequestService from "@/services/PendingRequestService";
// eslint-disable-next-line
/* eslint-disable */
import RaceServices from "@/services/RaceServices";
import Header from "@/components/dashboard/Header";
export default {
  data() {
    return {
      loading: null,
      dialogNote: {},
      TabItems: [{ title: "متقاضیان", path: "Users", icon: "account_circle" }],
      adminTableHeader: [
        {
          text: "نام کاربری",
          sortable: true,
          value: "agent.username",
          align: "right"
        },
        {
          text: "نام و نام خانوادگی",
          sortable: true,
          value: "agent.name",
          align: "right"
        },
        {
          text: "تلفن",
          sortable: false,
          value: "agent.phone",
          align: "right"
        },
        {
          text: "ایمیل",
          sortable: false,
          value: "agent.email",
          align: "right"
        },
        {
          text: "نام مسابقه",
          sortable: true,
          value: "race.name",
          align: "right"
        },
        {
          text: "نوع مسابقه",
          sortable: true,
          value: "race.raceCategory",
          align: "right"
        },
        {
          text: "تاریخ شروع",
          sortable: true,
          value: "race.startDate",
          align: "right"
        },
        {
          text: "تاریخ پایان",
          sortable: true,
          value: "race.endDate",
          align: "right"
        },
        {
          text: "ظرفیت",
          sortable: true,
          value: "race.totalCapacityCount",
          align: "right"
        },
        {
          text: "آخرین وضعیت",
          sortable: false,
          value: "null",
          align: "right"
        },
        {
          text: "موافقت                                   ",
          sortable: false,
          value: "null",
          align: "right"
        }
      ],
      pendingItems: [],
      disabledUserTableItems: [],
      userDeletedDataTableLoading: true,
      datatableBool: true,
      res: null,
      msg: null,
      color: null,
      snackbar: false
    };
  },
  components: {
    Header
  },
  async mounted() {
    // if (this.$store.state.user.type.id == 2) {
    //   this.$router.go(-1);
    // }
    setTimeout(() => {
      this.datatableBool = false;
    }, 8000);
    try {
      this.pendingItems = (await PendingRequestService.index()).data;
      console.log(this.pendingItems);
      this.datatableBool = false;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    async accept(agentID, raceID, id) {
      try {
        console.log(agentID + "  " + raceID + "  " + id);
        this.loading = true;
        this.res = await PendingRequestService.accept(agentID, raceID, id);
        this.loading = false;
        console.log(this.res.request.response);
        if (this.res.request.response == 1) {
          this.msg = "موفق!";
          this.snackbar = true;
          this.color = "success";
          this.$router.go();
        } else if (this.res.request.response == 0) {
          this.msg = "ناموفق!بعدا تلاش کنید";
          this.snackbar = true;
          this.color = "error";
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.margin-top-40px {
  margin-top: 40px;
}
.margin-top-20px {
  margin-top: 20px;
}
</style>
